import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { collection, onSnapshot, query } from 'firebase/firestore';
import { url } from '../container';
import { FirestoreService } from '../firestore-service.service';
import { getStorage, ref as refStorage, getDownloadURL } from "firebase/storage"
import { MatDialog } from '@angular/material/dialog';
import { ImagepopupComponent } from '../imagepopup/imagepopup.component';
import { ConfirmingDialogComponent } from '../confirming-dialog/confirming-dialog.component';
import { SearchService } from '../search.service';
import { environment } from 'src/environments/environment';
import { GeminiService } from '../gemini.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

interface FieldSummary {
  fieldName: string;
  uniqueValues: Record<string, number>;
}

@Component({
    selector: 'app-attachedfiles',
    templateUrl: './attachedfiles.component.html',
    styleUrls: ['./attachedfiles.component.scss'],
    standalone: true,
    imports: [
      CommonModule, 
      FormsModule,
      ConfirmingDialogComponent
    ],
})
export class AttachedfilesComponent implements OnInit {
  @Input()organizationKey: string = "";
  @Input()projectKey: string = "";
  @Input()contentKey: string = ""
  @Input()canDelete: boolean = false;
  @Input()smallSplash: boolean = false
  @Input()showSelectionTickers = false
  @Input()site: string = environment.site
  @Input()canUseAI: boolean = false
  @Input()userId: string = "";
  @Output() sendImageUrl = new EventEmitter<string>();
  @Output() sendCheckedDocumentKey = new EventEmitter<string>();
  @Output() addHTMLField = new EventEmitter<{"content": string}>();
  @Output() addTableField = new EventEmitter<any[]>();
  @Output() addLabelField = new EventEmitter<string>();
  @Output() isLoading = new EventEmitter<boolean>();
  @Output() orderGenerateDescription = new EventEmitter<string>();
  unsubscribeImages: any;
  imageURLs: url[] = []
  imageCount: number = 0
  didSendImage: boolean = false
  image: any;
  imageClassStyle = ""
  colNumber: number = 0

  constructor(private firestoreService: FirestoreService, public dialog: MatDialog, private search: SearchService, private gemini: GeminiService) { }

  ngOnInit() {
    this.startListeningToAttachedFiles()
    this.imageClassStyle = this.calculateColClass(this.imageURLs.length)
  }

  startListeningToAttachedFiles() {
    const db = this.firestoreService.getApps()
    const q = query(collection(db, "organizations", this.organizationKey, "content", this.contentKey, "images"));
    if (this.unsubscribeImages) {
      this.unsubscribeImages()
    }

    let uI = onSnapshot(q, (snapshot) => {
      this.imageURLs.length = 0;
      snapshot.forEach((child) => {
        let imagePath: any = child.get("url")
        let imageType: string = child.get("type")
        let coverImageURL = child.get("coverImageURL")
        let imageKey = child.id
        const storage = getStorage();
        const imageRef = refStorage(storage, imagePath);
        getDownloadURL(imageRef)
            .then((url) => {
              if (this.didSendImage == false && imageType.includes('image')) {
                this.sendImageUrl.emit(url) // send first image to parent component for potential generating description
                this.didSendImage = true
              }
              this.imageCount += 1
              if (this.imageCount > 3) {
                this.imageCount = 3
              }
              if (coverImageURL != undefined) { // nie wiem po co jest ten fragment kodu!!!
                const coverImageRef = refStorage(storage, coverImageURL);
                getDownloadURL(coverImageRef)
                .then((coverUrl) => {
                  this.imageURLs.push({"url": url, "type": imageType, "imageKey": imageKey, "coverImageURL": coverUrl, "isChecked": false, "isAnalyzed": false})

                })
              } else { // cover image doesnt exist
                this.imageURLs.push({"url": url, "type": imageType, "imageKey": imageKey, "coverImageURL": "", "isChecked": false, "isAnalyzed": false})              
              }
            })
      });
      this.imageClassStyle = this.calculateColClass(this.imageURLs.length)
    })
    uI = this.unsubscribeImages;
  }

  removeImage(image: url) {
    const dialogConfirmingRef = this.dialog.open(ConfirmingDialogComponent, {
      data: {"content": "Are you sure to remove this file?", "onlyCloseButton": false}
    });
    dialogConfirmingRef.afterClosed().subscribe((r) => {
      if (r == true) {
        this.firestoreService.removeImage(this.organizationKey, this.contentKey, image.imageKey, image.url)
        this.imageCount -= 1
        if (this.imageCount < 0) {
          this.imageCount = 0
        }
      }
    })

  }

  showImageDetailsPopup(url: string) {
    const dialogRef = this.dialog.open(ImagepopupComponent, {
      // width: '80%',
       data: url
     });
  }  

  calculateColClass(imageCount: number): string {
    if (imageCount === 1) {
      // 1 image should take full width on any screen size
      return 'col-12';
    } else if (imageCount === 2) {
      // 2 images take half width on large and medium screens, full width on small screens
      return 'col-12 col-md-6 col-xxl-6';
    } else if (imageCount === 3) {
      // 3 images take one third width on large screens, half on medium screens, full width on small screens
      return 'col-12 col-md-4 col-xxl-4';
    } else if (imageCount >= 4 && imageCount < 5) {
      // 4 images take up one fourth width on large, third on medium, full on small
      return 'col-12 col-md-4 col-lg-3 col-xxl-3';
    } else {
      // 5 or more images
      return 'col-12 col-md-4 col-lg-2 col-xxl-2';
    }
  }

  checkImage(index: number) {
    for (let i = 0; i < this.imageURLs.length; i++) {
      if (i == index) {
        this.imageURLs[i].isChecked = true
        this.sendCheckedDocumentKey.emit(this.imageURLs[i].imageKey)
      } else {
        this.imageURLs[i].isChecked = false
      }
    }
  }

  async getAudioTranscription(path: string, fileType: string) {
    this.isPreparingAduioTranscription = true
    this.isLoading.emit(true)
    this.firestoreService.showSnackBar("Extracting audio transcription, don't close this page...")
    return await this.search.getGeminiAudioTranscription(path, fileType).then((result: any) => {
      this.firestoreService.showSnackBar("Audio transcription has been extracted.")
      this.addHTMLField.emit({"content": result})
      this.isLoading.emit(false)
      this.isPreparingAduioTranscription = false
      return result
    }).catch((error: any) => {
      console.error("trasnsciption error", error)
      this.firestoreService.showSnackBar("Error during audio transcription extraction.")
      this.isPreparingAduioTranscription = false
      this.isLoading.emit(false)
    })
  }

  async convertCSVToTableField(path: string) {
    this.isLoading.emit(true)
    this.firestoreService.showSnackBar("Extracting CSV data, don't close this page...")
    return await this.search.getCSVData(path).then((result: any) => {
      this.firestoreService.showSnackBar("CSV data has been extracted.")
     // this.addHTMLField.emit({"content": result})
     this.addTableField.emit(result)
      this.isLoading.emit(false)
      return result
    }).catch((error: any) => {
      this.firestoreService.showSnackBar("Error during the CSV extraction.")
      this.isLoading.emit(false)
    })
  }

  async analyzeCVSData(path: string) {
    this.imageURLs.forEach((image: any) => {
      if (image.url == path) {
        image.isAnalyzed = true
      }
    })
    this.isLoading.emit(true)
    this.firestoreService.showSnackBar("Extracting CSV data, don't close this page...")
    const data = await this.search.getCSVData(path).then((result: any) => {
      this.firestoreService.showSnackBar("CSV data has been extracted.")
      return result
    }).catch((error: any) => {
      console.error("error", error)
      this.firestoreService.showSnackBar("Error during the CSV extraction.")
      this.isLoading.emit(false)
    })
    const frequency = this.summarizeResponses(data)
    const threshold = Math.min(Math.floor(data.length/10), 5)
    const pairsOccurrencesResult = this.getSimilarPairs(data, threshold);
    const prompt1 = `Analyze the following data and provide a summary of the most common values for each field and give interesting insights. If there is number of occurrences present referring to an insight, provide it as well. Return only the summary in langauge of input data, in json format [{"insight": <description of insight>, "occurences": <number of occurences>}, ...]. \n\n`+JSON.stringify(frequency)
    const prompt2 = `Analyze the following data and provide a summary of the most common pairs of values given by respondents and give interesting insights. If there is number of occurrences present referring to an insight, provide it as well. Return only the summary in langauge of input data, in json format [{"insight": <description of insight>, "occurences": <number of occurences>}, ...]. \n\n`+JSON.stringify(pairsOccurrencesResult)
    const promiseArray: Promise<any>[] = []
    let insightArray1: any[] = []
    this.firestoreService.showSnackBar("Extracting insights from the CSV data, don't close this page...")
    promiseArray.push(this.gemini.getGeminiResponseSimple(this.organizationKey, this.projectKey, this.userId, prompt1, 1000, false, "gemini-2.5-flash", 0).then((result: any) => {
      insightArray1 = this.search.extractJsonFromString(result.responseText)
    }))
    let insightArray2: any[] = []
    promiseArray.push(this.gemini.getGeminiResponseSimple(this.organizationKey, this.projectKey, this.userId, prompt2, 1000, false, "gemini-2.5-flash", 0).then((result: any) => {
      insightArray2 = this.search.extractJsonFromString(result.responseText)
    }))
    await Promise.all(promiseArray)

    if (insightArray1.length > 0 || insightArray2.length > 0) {
      this.addLabelField.emit("Insights extracted from the CSV file")
      insightArray1.forEach((insight: any) => {
        this.addHTMLField.emit({"content": insight.insight})
      })
      this.firestoreService.showSnackBar("100 % of insights extracted from the CSV file")
      insightArray2.forEach((insight: any) => {
        this.addHTMLField.emit({"content": insight.insight})
      })
    } else {
      this.firestoreService.showSnackBar("No insights found in the CSV data.")
    }
    this.isLoading.emit(false)
  }

  summarizeResponses(responses: any[]): FieldSummary[] { // for each question in the csv file, provide a summary of the most common values and the number of occurrences
    const fieldSummaries: { [key: string]: FieldSummary } = {};
    for (const response of responses) {
        for (const [field, value] of Object.entries(response)) {
            if (field === "#") continue; // Skip the "#" field

            if (!fieldSummaries[field]) {
                fieldSummaries[field] = { fieldName: field, uniqueValues: {} };
            }

            if (value !== null) {
                const stringValue = value as string;
                if (fieldSummaries[field].uniqueValues[stringValue]) {
                    fieldSummaries[field].uniqueValues[stringValue]++;
                } else {
                    fieldSummaries[field].uniqueValues[stringValue] = 1;
                }
            }
        }
    }
    return Object.values(fieldSummaries);
  }

  getSimilarPairs(data: any[], threshold: number): { firstValue: string; secondValue: string; occurrences: number }[] {
    const excludeFields = [
      "#",
      "Response Type",
      "Start Date (UTC)",
      "Stage Date (UTC)",
      "Submit Date (UTC)",
      "Network ID",
      "Tags",
      "Dzięki, to koniec! Podaj mi swój e-mail - otrzymasz pierwszeństwo zakupu biletu na następne wydarzenie!",
    ];
  
    // Map to store pair counts
    const pairCounts: { [key: string]: number } = {};
  
  // Process each response
  data.forEach((response) => {
    // Collect "question: answer" pairs from the response, excluding specified fields
    const answerPairs = Object.keys(response)
      .filter((key) => !excludeFields.includes(key) && response[key])
      .map((key) => `${key}: ${response[key]}`);

    // Generate all unique pairs of "question: answer" combinations for this response
    for (let i = 0; i < answerPairs.length; i++) {
      for (let j = i + 1; j < answerPairs.length; j++) {
        const value1 = answerPairs[i];
        const value2 = answerPairs[j];
        // Create a unique key for the pair (sorted to handle duplicates)
        const pairKey = [value1, value2].sort().join("|||");
        pairCounts[pairKey] = (pairCounts[pairKey] || 0) + 1;
      }
    }
  });

  // Convert the pair counts to an array of objects
  const result = Object.entries(pairCounts).map(([key, count]) => {
    const [firstValue, secondValue] = key.split("|||");
    return { firstValue, secondValue, occurrences: count };
  });

    result.sort((a, b) => b.occurrences - a.occurrences);
    return result.filter(pair => pair.occurrences >= threshold);
  }

  isCSVFile(file: File) {
    return file.type === 'text/csv' || file.name.endsWith('.csv');
  }

  isPreparingAduioTranscription = false

  async extractAudioFromVideo(url: string, fileType: string) {
    this.imageURLs.forEach((image: any) => {
      if (image.url == url) {
        image.isAnalyzed = true
      }
    })
    this.isPreparingAduioTranscription = true
    this.firestoreService.showSnackBar("Extracting audio from the video, don't close this page...")
 
    await this.search.getGeminiAudioTranscription(url, fileType).then((result: any) => {

      if (result) {

        this.addLabelField.emit("Audio transcription")
        this.addHTMLField.emit({"content": result})
        this.firestoreService.showSnackBar("Audio has been extracted and added to the content.")
      } else {
        this.firestoreService.showSnackBar("No text has been extracted from the audio.")
      }
      this.isPreparingAduioTranscription = false
      return result
    }).catch((error: any) => {
      console.error("error", error)
      this.firestoreService.showSnackBar("Error during the audio extraction.")
      this.isPreparingAduioTranscription = false
    })
  }

  extractImageText(url: string) {
    this.imageURLs.forEach((image: any) => {
      if (image.url == url) {
        image.isAnalyzed = true
      }
    })
    this.orderGenerateDescription.emit(url)
  }


}
